class RotateUnit {
    constructor(adorner, shapes, undoRotates) {
        this.shapes = shapes;
        this.undoRotates = undoRotates;
        this.title = 'Rotation';
        this.redoRotates = [];
        this.redoAngle = adorner._angle;
        this.adorner = adorner;
        this.center = adorner._innerBounds.center();
        for (let i = 0; i < this.shapes.length; i++) {
            const shape = this.shapes[i];
            this.redoRotates.push(shape.rotate().angle);
        }
    }
    undo() {
        let i, shape;
        for (i = 0; i < this.shapes.length; i++) {
            shape = this.shapes[i];
            shape.rotate(this.undoRotates[i], this.center, false);
            if ('layout' in shape) {
                shape.layout(shape);
            }
            shape.updateModel();
        }
        if (this.adorner) {
            this.adorner._initialize();
            this.adorner.refresh();
        }
    }
    redo() {
        let i, shape;
        for (i = 0; i < this.shapes.length; i++) {
            shape = this.shapes[i];
            shape.rotate(this.redoRotates[i], this.center, false);
            if ('layout' in shape) {
                shape.layout(shape);
            }
            shape.updateModel();
        }
        if (this.adorner) {
            this.adorner._initialize();
            this.adorner.refresh();
        }
    }
}

export { RotateUnit };
